<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ 'main.nav.links.licence.fullLabel' | translate}}
                <app-tooltip [text]="'main.nav.links.licence.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ng-container *ngIf="!isEditMode">
            <section>
                {{ licence.text.shortLabel }} - {{ licence.organism.text.shortLabel }} ({{ licence.language.codeISO }})
            </section>

            <section>
                <mat-icon aria-label="Checked" [ngClass]="{checked: licence.organism.isPublic}">
                    {{ licence.organism.isPublic ? 'check_box' : 'check_box_outline_blank' }}
                </mat-icon>
                <span>
                    {{ 'users.licencesList.isPublic.shortLabel' | translate }}
                </span>
            </section>

            <button mat-icon-button class="action-button" color="accent"
                [matTooltip]="'users.licencesList.edit.summary' | translate"
                (click)="onEdit()">
                <mat-icon aria-label="Edit">edit</mat-icon>
            </button>
        </ng-container>
        <app-licence-edit *ngIf="isEditMode" [licence]="licence" (editFinished)="onCancelEdit()"></app-licence-edit>
    </mat-card-content>
</mat-card>
